module.exports = __webpack_public_path__ + "img/welcome.53dfedf0.png";